import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-state--Signed",
  "use": "icon-state--Signed-usage",
  "viewBox": "0 0 59.643 50.913",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 59.643 50.913\" id=\"icon-state--Signed\">\n<g id=\"icon-state--Signed_state--Signed\">\n\t<polyline style=\"fill:none;stroke:#4CBAC0;stroke-width:10.44;stroke-miterlimit:10;\" points=\"55.631,3.34 22.151,43.56 \n\t\t3.341,27.89 \t\" />\n</g>\n<g id=\"icon-state--Signed_Layer_1\">\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol